import { render, staticRenderFns } from "./recruitment-header-section.vue?vue&type=template&id=2f8c6223&scoped=true"
import script from "./recruitment-header-section.vue?vue&type=script&lang=js"
export * from "./recruitment-header-section.vue?vue&type=script&lang=js"
import style0 from "./recruitment-header-section.vue?vue&type=style&index=0&id=2f8c6223&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8c6223",
  null
  
)

export default component.exports